export const keys = {
    all: ["tag"],
    histories: () => [
        ...keys.all,
        "history"
    ],
    history: (groupID: number,
         tagID: number | undefined,  
         beginDate: Date | undefined, 
         endDate: Date | undefined, 
         maxRowCount: number | undefined) => [
        ...keys.histories(),
        {
            groupID,
            tagID,
            beginDate,
            endDate,
            maxRowCount
        }
    ]
};
